import { Box, Stack, Typography } from '@mui/material';
import { CSSProperties } from 'react';
import { colors } from '../../../../../assets/themes/colors';
import { VyDescriptionTitle } from '../../../../../components/new-design/data-display/VyDescriptionTitle/VyDescriptionTitle';
import { SIZES } from '../../../../../components/types/sizes';
import { FC } from 'react';
import { isNotNullOrUndefined } from '@vy/utils';
import { PercentageChip } from '../../../../../components/utility/PercentageChip';
import { getSelectorAttribute } from '@vy/app-selectors';
import { WarningFilled } from '@vy/ui-design-system';
import { Link } from 'react-router-dom';

export type NavigationProps = { to: string; label: string };

type AnalyticMetricV2Props = {
  titleText: string;
  value: number;
  prevValue?: number;
  growthRateLabel?: string;
  formatter?: (value: number) => string;
  boldTitle?: boolean;
  valueFontSize?: number;
  titleSx?: CSSProperties;
  dataVy?: string;
  error?: boolean;
  centeredValueAlignment?: boolean;
  navigationProps?: NavigationProps;
};

export const AnalyticMetricV2: FC<AnalyticMetricV2Props> = ({
  value,
  prevValue,
  titleText,
  formatter,
  growthRateLabel,
  titleSx,
  error,
  valueFontSize = 28,
  boldTitle = true,
  centeredValueAlignment = false,
  dataVy,
  navigationProps,
}) => {
  const selectorProps = isNotNullOrUndefined(dataVy) ? getSelectorAttribute(dataVy) : {};
  const displayValue = formatter?.(value) ?? value;

  return (
    <Box {...selectorProps}>
      <VyDescriptionTitle
        title={titleText}
        cardSx={{
          '& .MuiCardHeader-title': {
            fontSize: '12px',
            fontWeight: '400 !important',
            color: colors.grey[60],
            marginBottom: '12px',
            ...titleSx,
          },
        }}
        subTitle={
          <Stack>
            <Stack
              direction="row"
              sx={{
                gap: 1,
                alignItems: "center",
                justifyContent: centeredValueAlignment ? 'center' : 'flex-start'
              }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: valueFontSize,
                  color: '#01060D'
                }}>
                {displayValue}
              </Typography>

              {error && <WarningFilled width={14} height={14} viewBox="0 0 24 24" color="#E91E63" />}
            </Stack>

            {isNotNullOrUndefined(prevValue) && (
              <Box>
                <PercentageChip
                  oldValue={prevValue}
                  newValue={value}
                  postfix={growthRateLabel}
                  bold={false}
                  arrowIconSize={14}
                />
              </Box>
            )}
            {isNotNullOrUndefined(navigationProps) && (
              <Link to={navigationProps.to} style={{ color: colors.blue[50], fontSize: '12px' }}>
                {navigationProps.label}
              </Link>
            )}
          </Stack>
        }
        boldTitle={boldTitle}
        size={SIZES.LARGE}
      />
    </Box>
  );
};
